var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-in w-lg-520px bg-white border-radius-s shadow-sm mx-auto mb-l",class:_vm.isMobile ? 'p-l' : 'p-2xl'},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }